import { FC, useEffect, useLayoutEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import GradeRaceTemplate from '@/components/templates/Schedule/GradeRace';
import { DATE_PARAM_KEY } from '@/config/constants/query';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import { dayjst } from '@/lib/dayjst';
import { client } from '@/lib/microcms';

const Calendar: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  const location = useLocation();

  const paramDate = new URLSearchParams(location.search).get(DATE_PARAM_KEY);
  const targetDate = paramDate ? dayjst(paramDate) : dayjst();

  const { data } = useQuery({
    queryKey: ['graderace', targetDate.format('YYYY')],
    queryFn: async () =>
      client.getContents('graderace', {
        limit: 1000,
        filters: `heldFirstDate[greater_than]${targetDate
          .startOf('year')
          .toISOString()}[and]heldLastDate[less_than]${targetDate
          .endOf('year')
          .toISOString()}`,
      }),
  });

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'グレードレース',
        to: '/graderace',
      },
      {
        name: targetDate.format('YYYY年'),
        to: '',
      },
    ]);
  }, [paramDate]);

  const title = location.search
    ? `${targetDate.format('YYYY年')}のグレードレース一覧`
    : `グレードレース一覧 ${targetDate.format('YYYY年')}`;

  return (
    <>
      <Helmet
        meta={{
          title: `競輪 ${title}`,
          description: `競輪の${targetDate.format(
            'YYYY年',
          )}グレードレース一覧です。%s`,
          keywords: `${title},%s`,
        }}
      />
      <GradeRaceTemplate date={targetDate} gradeRaces={data || []} />
    </>
  );
};

export default Calendar;
